export const IMPORT_GIT = {
  MODAL_TITLE: "Import via Git",
  IMPORT_CTA: "Import",
  WAIT_TEXT: "Please wait while we import via Git..",
};

export const IMPORT_OVERRIDE_MODAL = {
  TITLE: "Override existing {{artifactType}}?",
  DESCRIPTION:
    "{{newArtifactName}} already exists in this workspace as {{oldArtifactName}}. Do you want to override it with the imported {{artifactType}}?",
  CANCEL_BTN: "Cancel",
  OVERRIDE_BTN: "Override",
};

export const CONNECT_GIT = {
  MODAL_TITLE: "Configure Git",
  CHOOSE_PROVIDER_CTA: "Configure Git",
  GENERATE_SSH_KEY_CTA: "Continue",
  CONNECT_CTA: "Connect Git",
  CHOOSE_PROVIDER_STEP_TITLE: "Choose a Git provider",
  GENERATE_SSH_KEY_STEP_TITLE: "Enter Repository URL",
  ADD_DEPLOY_KEY_STEP_TITLE: "Set Up SSH Key",
  WAIT_TEXT: "Please wait while we connect to Git...",
  PREV_STEP: "Previous step",
};

export const QUICK_ACTIONS = {
  CONNECT_BTN_NOT_LIVE_YET: "It's not live for you yet",
  CONNECT_BTN_COMING_SOON: "Coming Soon!",
  CONNECT_BTN_CTA: "Connect Git",
  CONNECT_BTN_CONTACT_ADMIN:
    "Please contact your workspace admin to connect your artifact to a Git repo",
};

export const OPS_MODAL = {
  TAB_RELEASE: "Release",
};

export const TAB_RELEASE = {
  TITLE: "Release a new version",
  RELEASE_BTN: "Release",
};

export const RELEASE_VERSION_RADIO_GROUP = {
  TITLE: "Version",
  LAST_RELEASED: "Last released",
};

export const RELEASE_NOTES_INPUT = {
  TITLE: "Release notes",
  PLACEHOLDER: "Your release notes here",
};

export const ARTIFACT_SSH_KEY_MANAGER = {
  NO_KEYS_TITLE: "",
  NO_KEYS_DESCRIPTION: "",
  CREATE_KEY_CTA: "",
};

export const LATEST_COMMIT_INFO = {
  TITLE: "Commit",
  LOADING_COMMIT_MESSAGE: "Fetching latest commit...",
  NO_COMMIT_MESSAGE: "No commit message found",
};
